// Textos del widget del buscador en "es".
//
// GENERADO por scripts/f5-build/traducciones.js desde la tabla `traducciones`.
// No editar a mano: se regenera con
//     node scripts/f5-build/traducciones.js
//
// Van congelados en el bundle porque el widget no puede llamar a {tr} desde fuera de
// renfeviajes. Cambiar un rótulo exige rebuild y despliegue, no un UPDATE.
// Volcado: 2026-09-24 · 56 textos.

export const textos = {
  188: "Niños",
  416: "Desde",
  7236: "Estación de origen",
  7237: "Estación de destino",
  7238: "Seleccione una estación válida",
  7239: "Niños (0-13)",
  7240: "Niños (0-3)",
  7241: "Sin ocupar plaza",
  7242: "Listo",
  7243: "Borrar fechas",
  7244: "Buscar",
  7245: "Pasajero",
  7246: "Pasajeros",
  7247: "Busca tu producto o ciudad aquí",
  7248: "Actividad",
  7249: "Buscar Hotel",
  7259: "Seleccione una opción válida",
  7331: "Tren + Hotel / Ocio",
  7336: "¿Quieres añadir hotel al viaje?",
  7337: "No",
  7338: "Selecciona pasajeros",
  7339: "Más de 13 años",
  7340: "De 0 a 13 años",
  7341: "De 0 a 3 años. No ocupan plaza",
  7386: "Tren + Coche de alquiler",
  7388: "Edad conductor",
  20012: "Aviso",
  20013: "En paquetes con hotel, no es posible seleccionar el mismo dia de ida y vuelta",
  20766: "Sí",
  20808: "Hasta",
  20814: "Productos",
  20815: "Destinos",
  24531: "Nº de Adultos",
  24543: "Edades",
  24560: "Ocio",
  24642: "Habitaciones",
  24643: "Habitación",
  24851: "Seleccionar",
  25940: "Habitacion",
  25942: "Adultos",
  25953: "1 Habitacion, 2 Adultos",
  25967: "Fecha de salida del Hotel",
  41044: "Ciudad",
  45897: "Sólo ida",
  45898: "Ida y vuelta",
  46510: "Cancelar",
  46615: "Sin regreso",
  46629: "escoger horarios",
  46630: "aceptar",
  46641: "Seleccione",
  87088: "Viaje ida y vuelta",
  147090: "Hotel",
  344623: "Viaje sólo ida",
  1479751: "Tren + Hotel + Ocio",
  1479756: "Fecha Entrada Hotel",
  1479757: "Fecha Salida Hotel",
  2011810: "¿Desde cuándo hasta cuándo quieres el coche?",
}
